export class KeyboardHelper {
  public static adjustUIForKeyboard(keyboardHeight: number, activeElement: Element | undefined): void {
    if (!activeElement) {
      return;
    }
    const rect = activeElement.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    // If the input is below the visible area, scroll it into view
    if (rect.bottom > viewportHeight - keyboardHeight) {
      activeElement.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
  }

  public static resetUIAfterKeyboard(activeElement: Element | undefined): void {
    activeElement?.scrollTo(0, 0);
  }
}
